import { render, staticRenderFns } from "./ModalOsAVencerArmazem.vue?vue&type=template&id=454cf600&scoped=true&"
import script from "./ModalOsAVencerArmazem.vue?vue&type=script&lang=js&"
export * from "./ModalOsAVencerArmazem.vue?vue&type=script&lang=js&"
import style0 from "./ModalOsAVencerArmazem.vue?vue&type=style&index=0&id=454cf600&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454cf600",
  null
  
)

export default component.exports